var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "make-invoice-adjust-balance-dialog",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("CargoMsg.Cargo_TelexReleaseMaterial"),
        width: "300px",
        "close-on-click-modal": false,
        "show-close": true
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        },
        close: _vm.cancel
      }
    },
    [
      _c("div", [
        _c(
          "div",
          { staticClass: "form-row", staticStyle: { "min-height": "200px" } },
          [
            _vm._v(" VSL/VOY：" + _vm._s(_vm.voyageFlight) + " "),
            _c("p"),
            _vm._v(" MBL：" + _vm._s(_vm.mblNo) + " "),
            _c("p"),
            _vm._v(" HBL：" + _vm._s(_vm.hblNo) + " "),
            _c("p"),
            _vm._v(" C/N(QTY：" + _vm._s(_vm.containerNo) + " "),
            _c("p"),
            _vm._v(" POD：" + _vm._s(_vm.dischargingPortCode)),
            _c("p"),
            _vm._v(" ETA：" + _vm._s(_vm.eta)),
            _c("p")
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }